import React, { useState } from "react";
import { resetPassword } from "@aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import toastr from "toastr";
import Layout from "../layout/Layout";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!email) {
      toastr.error("Email is required");
      return;
    }

    setLoading(true);
    try {
      await resetPassword({ username: email });
      toastr.success("Verification code sent to your email!");
      navigate("/reset-password", { state: { email } });
    } catch (error) {
      toastr.error(error.message || "Failed to send verification code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="position-absolute top-0 start-0 m-4 d-flex align-items-center">
        <img
          src="/images/odir-logo.png"
          alt="ODIR Logo"
          style={{ height: "40px", width: "auto" }}
        />
        <span className="ms-2 fw-bold" style={{ fontSize: "1.5rem", color: "#342ead" }}>ODIR</span>
      </div>
      <div className="container-fluid">
        <div className="row h-100">
          <div className="col-lg-8 col-md-6 col-sm-12 position-relative d-flex align-items-center">
            <div className="text-center w-100 px-5">
              <h1 className="display-4 fw-bold mb-4" style={{ color: "#342ead" }}>
                Forgot Password?
              </h1>
              <p className="lead fs-4 text-muted">
                Enter your email and we'll send you a verification code
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 right-section">
            <div className="form mx-auto">
              <h3>Reset Password</h3>
              <p>Enter your email to receive a verification code</p>
              <form onSubmit={handleResetPassword}>
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-Login-Signup w-100"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Code"}
                </button>
              </form>

              <p className="mt-4 text-center">
                Remember your password?{" "}
                <a href="/login" className="primary-text">
                  Back to Login
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ForgotPasswordPage;
